// extracted by mini-css-extract-plugin
export default {"lista-menu":"componente-menu_lista-menu__+io9b","contenedor-menu":"componente-menu_contenedor-menu__FUec8"};